var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdultBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3875_103486",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#4F4F4F"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3875_103486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.05049 11.8479C6.05049 12.3582 6.05049 12.864 6.05049 13.3743C6.05049 13.9849 6.46896 14.3949 7.08303 14.3995C7.61522 14.3995 8.14286 14.3995 8.67505 14.3995C9.27092 14.3995 9.6894 13.9803 9.6894 13.3834C9.6894 12.3491 9.69395 11.3194 9.6894 10.2851C9.6894 10.1575 9.71669 10.0892 9.84405 10.0299C10.3444 9.79757 10.5946 9.38749 10.5991 8.83617C10.6037 8.08437 10.6037 7.33257 10.5991 6.58077C10.5946 5.61027 9.82131 4.83568 8.85245 4.83113C8.1929 4.83113 7.53334 4.82657 6.87379 4.83113C5.91857 4.83568 5.14531 5.61482 5.14531 6.57166C5.14076 7.32346 5.14076 8.07526 5.14531 8.82706C5.14985 9.38749 5.40458 9.79757 5.91403 10.0345C6.01865 10.0846 6.05503 10.1393 6.05503 10.2532C6.04594 10.7817 6.05049 11.3148 6.05049 11.8479Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.87896 4.41652C8.64768 4.41652 9.27539 3.78774 9.27539 3.01316C9.27539 2.23857 8.62493 1.59157 7.85621 1.60068C7.09204 1.60979 6.45978 2.25224 6.45978 3.01316C6.45978 3.79229 7.09659 4.42107 7.87896 4.41652Z",
    fill: "#4F4F4F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdultBlack);
export default __webpack_public_path__ + "static/media/adult_black.c17300ee7485c77801f22e68e15be4a9.svg";
export { ForwardRef as ReactComponent };